import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import type { SafeUrl } from '@angular/platform-browser';
import { DsIconModule } from '@skyeng/libs/shared/ui-kit-v2/icon';

@Component({
  selector: 'lab-attachment-chip',
  imports: [DsIconModule],
  templateUrl: './attachment-chip.component.html',
  styleUrls: ['./attachment-chip.component.scss'],
  host: {
    '[attr.data-test]': 'dataTest() || null',
    '[attr.data-testid]': 'testId() || null',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LaboratoryAttachmentChipComponent {
  readonly label = input.required<string>();
  readonly previewUrl = input<string | SafeUrl | null>(null);
  readonly previewAria = input<string | null>(null);
  readonly removeAria = input.required<string>();
  readonly dataTest = input<string>();
  readonly testId = input<string>();
  readonly previewDataTest = input<string>();
  readonly previewTestId = input('attachment-chip-preview');
  readonly removeDataTest = input<string>();
  readonly removeTestId = input('attachment-chip-remove');
  readonly previewRequested = output<void>();
  readonly removeRequested = output<void>();
}
